import { createAction } from 'redux-actions';
import {
  PapiDaSharedDeviationSubmitGroupDestinations,
  PapiAttachmentFile,
} from '@wix/da-papi-types';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { SUBMIT_POPUP_ERROR_CODE, actionKey } from '../constants';
import {
  NormalizedInitResponse,
  InitializeTierTagsPayload,
  InitializeTierTagsSuccessPayload,
  DefaultValues,
} from '../types';
import { SubmitFormParams } from '../../types';

/* All actions in this file are used by and related to the state of the deviation submit modal */

export const splashReady = createAction(
  `${actionKey}.SPLASH_READY`,
  () => ({})
);

export const setUploadStatus = createAction(
  `${actionKey}.SET_UPLOAD_STATUS`,
  (uploader: 'main' | 'pcp' | 'exclusive', status) => ({ uploader, status })
);

export const initialize = createAction(
  `${actionKey}.INITIALIZE`,
  ({ deviationId }) => ({ deviationId })
);

export const deinitialize = createAction(
  `${actionKey}.DEINITIALIZE`,
  () => ({})
);

export const initializeSuccess = createAction(
  `${actionKey}.INITIALIZE_SUCCESS`,
  (payload: NormalizedInitResponse & { scheduledPublishTime?: string }) =>
    payload
);

export const refresh = createAction(
  `${actionKey}.REFRESH`,
  ({ deviationId }) => ({ deviationId })
);

export const refreshSuccess = createAction(
  `${actionKey}.REFRESH_SUCCESS`,
  (payload: NormalizedInitResponse) => payload
);

export const initializeTierTags = createAction(
  `${actionKey}.INITIALIZE_TIER_TAGS`,
  (payload: InitializeTierTagsPayload) => payload
);

export const initializeTierTagsSuccess = createAction(
  `${actionKey}.INITIALIZE_TIER_TAGS_SUCCESS`,
  (payload: InitializeTierTagsSuccessPayload) => payload
);

export const initializeTierTagsError = createAction(
  `${actionKey}.INITIALIZE_TIER_TAGS_ERROR`,
  (errorMessage: string) => ({ errorMessage })
);

export const deviationSaveCancel = createAction(
  `${actionKey}.DEVIATION_SAVE_CANCEL`,
  () => ({})
);

export const deviationSaveError = createAction(
  `${actionKey}.DEVIATION_SAVE_ERROR`,
  (message: string, errorCode: SUBMIT_POPUP_ERROR_CODE) => ({
    message,
    errorCode,
  })
);

export const setDefaultValues = createAction(
  `${actionKey}.SET_DEFAULT_VALUES`,
  (defaultValues: DefaultValues) => ({ defaultValues })
);

export const pushSubmitModal = (
  deviationId: number,
  params: Partial<SubmitFormParams>
) =>
  pushModal(ModalType.DEVIATION_SUBMIT, {
    params: {
      deviationId,
      ...params,
    },
  });

export const pushOriginalSubmitModal = () =>
  pushModal(ModalType.ORIGINAL_DEVIATION, {
    wrapInModal: false,
  });

export const groupDestinationsFetch = createAction(
  `${actionKey}.GROUP_DESTINATIONS_FETCH`,
  (deviationId: number) => ({ deviationId })
);

export const groupDestinationsFetchSuccess = createAction(
  `${actionKey}.GROUP_DESTINATIONS_FETCH_SUCCESS`,
  (payload: PapiDaSharedDeviationSubmitGroupDestinations) => payload
);

export const groupDestinationsFetchError = createAction(
  `${actionKey}.GROUP_DESTINATIONS_FETCH_ERROR`,
  () => ({})
);

export const updatePcpAttachments = createAction(
  `${actionKey}.UPDATE_PCP_ATTACHMENTS`,
  (assets: PapiAttachmentFile[]) => ({ assets })
);

export const removePcpAttachment = createAction(
  `${actionKey}.REMOVE_PCP_ATTACHMENT`,
  (fileId: number | undefined) => ({ fileId })
);
